/* ==========================================================================
   cdc-product-tabs.js — Fiche produit : accordeons transformes en onglets
   --------------------------------------------------------------------------
   ROLE
   Transforme en onglets horizontaux les panneaux emis par blocks/accordion.liquid
   quand le reglage « Afficher comme onglet produit » est actif.

   Le HTML servi ne contient AUCUNE barre d'onglets : elle est construite ici, a
   partir des panneaux `[data-cdc-product-tab]`. Les panneaux sont groupes par
   parent commun puis par `data-cdc-tab-group`, ce qui permet plusieurs jeux
   d'onglets independants sur une meme page.

   ORIGINE
   Developpe et valide sur BRANCHE TAD MARKETING (#202174431570), ou ce script
   etait inline dans accordion.liquid et donc DUPLIQUE a chaque accordeon
   (4 copies, ~21 Ko de HTML en trop par page, plus un avertissement Theme Check).
   Ici : un seul fichier, charge une fois, mis en cache CDN.

   CHARGEMENT
   layout/theme.liquid, sur les pages produit uniquement, en `defer` — le DOM est
   donc complet a l'execution, pas besoin d'attendre DOMContentLoaded.

   MARKUP ATTENDU (cf. blocks/accordion.liquid)
       <div class="cdc-product-tab-item"
            data-cdc-product-tab
            data-cdc-tab-group="product-details"
            data-cdc-tab-title="Description"
            data-cdc-tab-id="<block.id>">
         <h3 class="cdc-product-tab-fallback-title">Description</h3>
         <div class="cdc-product-tab-content">...</div>
       </div>

   REPLI SANS JS
   Les panneaux sont visibles par defaut et portent un titre en clair. Ce script
   pose `data-cdc-tabs-ready` sur <html> une fois la barre construite ; le CSS
   masque alors ces titres. Si le script ne s'execute pas, la page reste lisible :
   panneaux empiles avec leurs intertitres.
   ========================================================================== */
(function () {
  var READY_ATTRIBUTE = 'data-cdc-tabs-ready';

  /* Remet le DOM dans son etat initial : indispensable avant chaque
     reconstruction (shopify:section:load reinjecte le markup d'origine). */
  function removeGeneratedTabs() {
    document.querySelectorAll('[data-cdc-tabs-navigation]').forEach(function (navigation) {
      navigation.remove();
    });

    document.querySelectorAll('[data-cdc-product-tab]').forEach(function (panel) {
      panel.hidden = false;
      panel.removeAttribute('role');
      panel.removeAttribute('aria-labelledby');
      panel.removeAttribute('tabindex');
      delete panel.cdcActivateTab;
    });

    document.documentElement.removeAttribute(READY_ATTRIBUTE);
  }

  function createTabGroup(panels, groupIndex) {
    if (!panels.length) return false;

    var firstPanel = panels[0];
    var parent = firstPanel.parentElement;

    if (!parent) return false;

    var groupName = firstPanel.dataset.cdcTabGroup || 'product-details';

    var navigation = document.createElement('div');
    navigation.className = 'cdc-product-tabs-navigation';
    navigation.setAttribute('role', 'tablist');
    navigation.setAttribute('aria-label', 'Informations sur le produit');
    navigation.setAttribute('data-cdc-tabs-navigation', groupName);

    parent.insertBefore(navigation, firstPanel);

    var buttons = [];

    function activateTab(activeIndex, focusButton) {
      panels.forEach(function (panel, index) {
        var active = index === activeIndex;
        var button = buttons[index];

        panel.hidden = !active;
        panel.setAttribute('tabindex', active ? '0' : '-1');

        button.setAttribute('aria-selected', active ? 'true' : 'false');
        button.setAttribute('tabindex', active ? '0' : '-1');
      });

      if (focusButton && buttons[activeIndex]) {
        buttons[activeIndex].focus();
      }
    }

    panels.forEach(function (panel, index) {
      var tabId = panel.dataset.cdcTabId || groupName + '-' + groupIndex + '-' + index;
      var panelId = panel.id || 'cdc-product-tab-panel-' + tabId;
      var buttonId = 'cdc-product-tab-button-' + tabId;

      panel.id = panelId;
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', buttonId);

      var button = document.createElement('button');
      button.type = 'button';
      button.id = buttonId;
      button.className = 'cdc-product-tabs-button';
      button.textContent = panel.dataset.cdcTabTitle || 'Onglet ' + (index + 1);
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-controls', panelId);
      button.setAttribute('aria-selected', 'false');
      button.setAttribute('tabindex', '-1');

      button.addEventListener('click', function () {
        activateTab(index);
      });

      /* Navigation clavier conforme au motif ARIA « tabs » :
         fleches pour circuler, Home/End pour les extremites. */
      button.addEventListener('keydown', function (event) {
        var nextIndex = index;

        if (event.key === 'ArrowRight') {
          nextIndex = (index + 1) % panels.length;
        } else if (event.key === 'ArrowLeft') {
          nextIndex = (index - 1 + panels.length) % panels.length;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = panels.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        activateTab(nextIndex, true);
      });

      panel.cdcActivateTab = function () {
        activateTab(index);
      };

      buttons.push(button);
      navigation.appendChild(button);
    });

    activateTab(0);
    return true;
  }

  function initializeProductTabs() {
    removeGeneratedTabs();

    var allPanels = Array.prototype.slice.call(
      document.querySelectorAll('[data-cdc-product-tab]')
    );

    /* Groupement par parent PUIS par nom de groupe : deux accordeons places
       dans des colonnes differentes forment deux jeux d'onglets distincts. */
    var groupsByParent = new Map();

    allPanels.forEach(function (panel) {
      var parent = panel.parentElement;
      if (!parent) return;

      var groupName = panel.dataset.cdcTabGroup || 'product-details';

      if (!groupsByParent.has(parent)) {
        groupsByParent.set(parent, new Map());
      }

      var groups = groupsByParent.get(parent);

      if (!groups.has(groupName)) {
        groups.set(groupName, []);
      }

      groups.get(groupName).push(panel);
    });

    var groupIndex = 0;
    var created = false;

    groupsByParent.forEach(function (groups) {
      groups.forEach(function (panels) {
        if (createTabGroup(panels, groupIndex)) created = true;
        groupIndex += 1;
      });
    });

    /* Le drapeau n'est pose que si au moins une barre existe : sans onglet,
       les titres de repli doivent rester visibles. */
    if (created) {
      document.documentElement.setAttribute(READY_ATTRIBUTE, '');
    }
  }

  initializeProductTabs();

  /* Customizer : une section rechargee reinjecte le markup d'origine. */
  document.addEventListener('shopify:section:load', initializeProductTabs);

  /* Customizer : selectionner un accordeon ouvre l'onglet correspondant. */
  document.addEventListener('shopify:block:select', function (event) {
    var selectedPanel =
      (event.target.closest && event.target.closest('[data-cdc-product-tab]')) ||
      document.querySelector('[data-cdc-tab-id="' + (event.detail && event.detail.blockId) + '"]');

    if (selectedPanel && typeof selectedPanel.cdcActivateTab === 'function') {
      selectedPanel.cdcActivateTab();
    }
  });
})();
